/*
 * Resolves swatches whose image is only known through assets/color-pattern-images.json (keyed by the option value
 * handle). Any element carrying data-color-pattern-handle is handled: product option swatches (snippets/option-value.liquid)
 * and cart line item swatches (snippets/line-item-options.liquid).
 */
(function () {
  if (window.__colorPatternLookupInitialized) return;
  window.__colorPatternLookupInitialized = true;

  const MAP_URL = document.currentScript && document.currentScript.dataset.mapUrl;
  if (!MAP_URL) return;

  let imageMapPromise = null;
  let scheduled = false;

  function loadImageMap() {
    if (!imageMapPromise) {
      imageMapPromise = fetch(MAP_URL)
        .then(r => (r.ok ? r.json() : null))
        .catch(() => null);
    }

    return imageMapPromise;
  }

  function resolveColorPatterns() {
    const elements = document.querySelectorAll('[data-color-pattern-handle]:not([data-color-pattern-resolved])');
    if (!elements.length) return;

    loadImageMap().then(imageMap => {
      // Keep the elements pending so a later re-render can retry when the map failed to load.
      if (!imageMap) return;

      elements.forEach(el => {
        el.dataset.colorPatternResolved = 'true';

        const url = imageMap[el.dataset.colorPatternHandle];
        if (!url) return;

        el.dataset.image = url;
        el.style.setProperty('--swatch-background', `url(${url})`);

        const colorDiv = el.querySelector('.variant-tooltip .variant-color');
        if (colorDiv) {
          const img = document.createElement('img');
          img.src = url;
          img.alt = 'Variant preview';
          img.width = 300;
          img.height = 300;
          colorDiv.replaceWith(img);
        }
      });
    });
  }

  function scheduleResolve() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      resolveColorPatterns();
    });
  }

  function init() {
    resolveColorPatterns();

    // The variant picker, quick buy, facets and cart drawer swap this markup over AJAX, so we watch the document
    // instead of resolving the swatches only once.
    new MutationObserver(scheduleResolve).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
